import { render } from "./SubjectDashboard.vue?vue&type=template&id=2554cd1a&scoped=true"
import script from "./SubjectDashboard.vue?vue&type=script&lang=js"
export * from "./SubjectDashboard.vue?vue&type=script&lang=js"

import "./SubjectDashboard.vue?vue&type=style&index=0&id=2554cd1a&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2554cd1a"]])

export default __exports__